import React from 'react';
import { Button } from 'antd';
import { SoundOutlined, UserOutlined, RobotOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';

interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
}

interface ChatMessageProps {
  message: Message;
  onPlayTTS?: () => void;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, onPlayTTS }) => {
  const isUser = message.role === 'user';

  return (
    <div style={{
      marginBottom: 20,
      display: 'flex',
      justifyContent: isUser ? 'flex-end' : 'flex-start',
      animation: 'slideIn 0.3s ease'
    }}>
      <div style={{
        maxWidth: window.innerWidth < 576 ? '85%' : '70%',
        display: 'flex',
        flexDirection: isUser ? 'row-reverse' : 'row',
        gap: 10
      }}>
        {/* Avatar */}
        <div style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: isUser
            ? 'linear-gradient(135deg, #EB2ADD 0%, #0D12F2 100%)'
            : 'linear-gradient(135deg, rgba(235, 42, 221, 0.15) 0%, rgba(13, 18, 242, 0.15) 100%)',
          border: isUser ? 'none' : '2px solid rgba(235, 42, 221, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: isUser ? '#fff' : '#EB2ADD',
          flexShrink: 0,
          fontSize: 16,
          boxShadow: isUser
            ? '0 4px 12px rgba(235, 42, 221, 0.3)'
            : '0 2px 8px rgba(0, 0, 0, 0.08)'
        }}>
          {isUser ? <UserOutlined /> : <RobotOutlined />}
        </div>

        {/* Message Bubble */}
        <div style={{
          background: isUser
            ? 'linear-gradient(135deg, #EB2ADD 0%, #0D12F2 100%)'
            : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: isUser ? 'none' : 'blur(10px)',
          color: isUser ? '#fff' : '#1a1a1a',
          padding: '12px 16px',
          borderRadius: 12,
          boxShadow: isUser
            ? '0 4px 16px rgba(235, 42, 221, 0.25), 0 2px 8px rgba(13, 18, 242, 0.15)'
            : '0 4px 16px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)',
          border: isUser ? 'none' : '1px solid rgba(0, 0, 0, 0.06)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease'
        }}>
          <div
            className={isUser ? 'chat-message-user' : 'chat-message-assistant'}
            style={{
              fontSize: 15,
              lineHeight: 1.6
            }}
          >
            <ReactMarkdown>{message.content}</ReactMarkdown>
          </div>

          {/* TTS Button for assistant messages */}
          {!isUser && onPlayTTS && (
            <div style={{ marginTop: 8 }}>
              <Button
                type="text"
                size="small"
                icon={<SoundOutlined />}
                onClick={onPlayTTS}
                style={{
                  padding: '4px 8px',
                  height: 'auto',
                  color: '#0D12F2',
                  fontWeight: 500,
                  transition: 'all 0.2s ease'
                }}
              >
                Ascolta
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;